import LeverageLogo from '@/assets/branding/leverage/leverage-logo.png';

const colors = {
  // Brand colors
  brand_primary: '#143359',
  brand_primary_hover: '#0D1B2D', // −10 L, −8 S
  brand_primary_highlight: '#2269C1', // +23 L, +7 S
  brand_primary_mid: '#1A467C', // +8 L,  +2 S
  brand_primary_dark: '#000000', // −25 L, −3 S (clamped)
  brand_secondary: '#080E18', // hue +4°, −15 L, −13 S
  brand_accent_start: '#234A78',
  brand_accent_end: '#1F7B7F',
  brand_accent_light_start: '#EAF0F8',
  brand_accent_light_end: '#DFF4F2',
  brand_complementary_accent: 'rgb(191,120,34)',
  brand_auth_gradient_mid: '#080E18',
  brand_auth_gradient_end: '#000000',
  brand_auth_warp_mid: '#1A467C',
};

export default {
  name: 'Leverage',
  isSAML: true,
  allowPersonalCourses: false,
  logo: LeverageLogo,
  colors,
};
